import { render, staticRenderFns } from "./a11y.vue?vue&type=template&id=767bdc04&"
import script from "./a11y.vue?vue&type=script&lang=js&"
export * from "./a11y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports